module.exports = __webpack_public_path__ + "img/testUSDC.9bfd64df.svg";